import React, { useEffect, useState } from 'react';
import Card from '@mui/material/Card';
import Typography from '@mui/material/Typography';
import useLocalStorage from 'src/shared/hooks/useLocalStorage';
import {
  Box, CardHeader, Paper, Grid, Stack, Tooltip,Avatar

} from '@mui/material';
import call from 'src/core/services/http';
import { useParams } from "react-router-dom";
import { toast } from 'react-toastify';
import Page from "src/shared/components/Page";
import CheckboxComponent from 'src/shared/components/checkbox';
import Title from 'src/shared/Text/Title';
import Iconify from '../components/Iconify';
import { styled, alpha } from '@mui/material/styles';



const IconStyle = styled(Iconify)(({ theme }) => ({
  width: 20,
  height: 20,
  marginTop: 1,
  flexShrink: 0,
  marginRight: theme.spacing(2),
}));



const MainSettings = () => {
  const [data, setData] = useState([]);
  const [profile, setProfile] = useState({})
  const [loading, setLoading] = useState(false);
  const [{ account_number,description }] = useLocalStorage('shop-details')



  return (
    <Page title='Settings'>
      <Grid container spacing={3}>
        <Grid item xs={12} md={4} lg={4}>
          <Card sx={{
            bgcolor: alpha('#1CCAFF', 0.08),
            // border: `solid 2px ${'#1CCAFF'}`,
            boxShadow: `inset 0 4px 8px 0 ${alpha('#1CCAFF', 0.24)}`,
          }} >
            <Stack spacing={2} sx={{ p: 3, textAlign: 'center', height: 370 }}>
              <Avatar
                displayName={profile.subscriber_details?.display_name}
                src='https://cdn.iconscout.com/icon/free/png-512/free-avatar-370-456322.png?f=webp&w=256'
                sx={{
                  mb: 2,
                  mx: 'auto',
                  borderWidth: 2,
                  borderStyle: 'solid',
                  borderColor: 'common.white',
                  width: { xs: 80, md: 80 },
                  height: { xs: 80, md: 80 },
                }}
              />
              <Box
                sx={{
                  ml: { md: 3 },
                  mt: { xs: 1, md: 0 },
                  color: 'common.black',
                  textAlign: { xs: 'center', md: 'left' },
                }}
              >
                <Typography variant="h4">{profile.subscriber_details?.display_name}</Typography>
                <Typography variant="body2" sx={{ color: 'text.primary', opacity: 0.72 }}>
                  Name &nbsp;
                  <Typography sx={{ opacity: 0.72 }}><strong> {description}</strong> </Typography>
                </Typography>
              </Box>
              <Stack direction={'row'} alignContent='space-between' justifyContent={'space-between'} >
              <IconStyle icon={'typcn:edit'} sx={{mx:40}} />
              </Stack>
              <Stack direction="row">
                <IconStyle icon={'ci:user-01'} />
                <Typography variant="body2">
                  Shop Name &nbsp;
                  <strong>{description}</strong>
                </Typography>
              </Stack>
              <Stack direction="row">
                <IconStyle icon={'eva:phone-fill'} />
                <Typography variant="body2" color="text.primary">
                  Account Number &nbsp;
                 <strong>{account_number}</strong> 
               
                </Typography>
              </Stack>
              <Stack direction="row">
                <IconStyle icon={'ci:calendar-days'} />
                <Typography variant="body2">
                   Date Joined &nbsp;
                  
                </Typography>
              </Stack>
            </Stack>
          </Card>
        </Grid>
        <Grid item xs={12} md={4} lg={7} spacing={3} >
          <Paper variant="outlined" sx={{ py: 2, textAlign: 'center', height: 370, px: 20 }}>
          <CardHeader
          title={<Title variant={'subtitle2'} text='Merchant Account Settings' sx={{ mb: 6 }} />}
        />
        
              <Stack spacing={3}>
                <Stack direction="row" justifyContent="space-between" alignItems="center">
                  <Typography gutterBottom variant="button" paragraph>
                    Allow Signatory Approval
                  </Typography>
                  <Stack direction="row" spacing={3} alignItems="center">
                    <Tooltip
                      title="Allows transactions to be approved by signatories in the system. Click the button on the right to turn on/off"
                      placement="bottom"
                      arrow
                    >
                      <Typography
                        sx={{
                          color: "#fff",
                          background: "#000",
                          textAlign: "center",
                          width: 20,
                          height: 20,
                          borderRadius: 50,
                          marginLeft: 4
                        }}
                      >
                        ?
                      </Typography>
                    </Tooltip>
                    <CheckboxComponent
                      acceptText={"Turned Off"}
                      negateText="Turned On"
                      checked={data.signatory_approval_required}
                      handleChange={() => { }}
                      loading={loading}
                      key="Checker Approval"
                    />
                  </Stack>
                </Stack>

                <Stack direction="row" justifyContent="space-between" alignItems="center">
                  <Typography gutterBottom variant="button" paragraph>
                    Allow Checker Approval
                  </Typography>
                  <Stack direction="row" spacing={3} alignItems="center">
                    <Tooltip
                      title="Allows transactions to be approved by checkers in the system. Click the button on the right to turn on/off"
                      placement="bottom"
                      arrow
                    >
                      <Typography
                        sx={{
                          color: "#fff",
                          background: "#000",
                          textAlign: "center",
                          width: 20,
                          height: 20,
                          borderRadius: 50,
                          marginLeft: 4
                        }}
                      >
                        ?
                      </Typography>
                    </Tooltip>
                    <CheckboxComponent
                      acceptText={"Turned Off"}
                      negateText="Turned On"
                      checked={data.checker_approval_required}
                      handleChange={() => { }}
                      loading={loading}
                      key="Checker Approval"
                    />
                  </Stack>
                </Stack>
              </Stack>
          
        
          </Paper>
        </Grid>
      </Grid>
    </Page>


  )
}

export default MainSettings;
